import { useRef, useState } from "react";
import { createPortal } from "react-dom";
import { X, ZoomIn, ZoomOut } from "lucide-react";

const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
const dist = (t) => Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);

export const ImageViewer = ({ url, onClose }) => {
  const [v, setV] = useState({ s: 1, x: 0, y: 0 });
  const g = useRef({});
  const lastTap = useRef(0);
  const zoom = (s) => setV((o) => (s <= 1 ? { s: 1, x: 0, y: 0 } : { ...o, s: clamp(s, 1, 5) }));
  const start = (e) => {
    const t = e.touches;
    if (t.length === 2) g.current = { pinch: dist(t), s: v.s };
    else if (t.length === 1) {
      const now = Date.now();
      if (now - lastTap.current < 300) zoom(v.s > 1 ? 1 : 2.5);
      lastTap.current = now;
      g.current = { px: t[0].clientX - v.x, py: t[0].clientY - v.y };
    }
  };
  const move = (e) => {
    const t = e.touches;
    if (t.length === 2 && g.current.pinch) zoom(g.current.s * (dist(t) / g.current.pinch));
    else if (t.length === 1 && v.s > 1 && g.current.px !== undefined) setV((o) => ({ ...o, x: t[0].clientX - g.current.px, y: t[0].clientY - g.current.py }));
  };
  const btn = "flex h-12 w-12 items-center justify-center rounded-full bg-white/15 text-white active:bg-white/30";
  return createPortal(
    <div data-testid="image-viewer" role="dialog" aria-label="Foto ampliada" className="fixed inset-0 z-[100] flex flex-col bg-black"
      style={{ touchAction: "none" }}>
      <div className="flex items-center justify-between p-3">
        <div className="flex gap-2">
          <button data-testid="image-viewer-zoom-out" aria-label="Diminuir" className={btn} onClick={() => zoom(v.s - 0.75)}><ZoomOut className="h-6 w-6" /></button>
          <button data-testid="image-viewer-zoom-in" aria-label="Aumentar" className={btn} onClick={() => zoom(v.s + 0.75)}><ZoomIn className="h-6 w-6" /></button>
        </div>
        <button data-testid="image-viewer-close" onClick={onClose} className="flex h-12 items-center gap-2 rounded-full bg-white px-5 text-base font-bold text-zap-deep">
          <X className="h-5 w-5" />Fechar
        </button>
      </div>
      <div className="flex min-h-0 flex-1 items-center justify-center overflow-hidden" onTouchStart={start} onTouchMove={move}
        onTouchEnd={(e) => { if (e.touches.length < 2) g.current = {}; }}
        onWheel={(e) => zoom(v.s - e.deltaY / 400)} onClick={(e) => e.target === e.currentTarget && v.s === 1 && onClose()}>
        <img data-testid="image-viewer-img" src={url} alt="Foto ampliada" draggable={false}
          className="max-h-full max-w-full select-none object-contain transition-transform duration-75"
          style={{ transform: `translate(${v.x}px, ${v.y}px) scale(${v.s})` }} />
      </div>
      <p className="px-4 pb-4 text-center text-sm text-white/70">Use dois dedos para aumentar ou diminuir. Toque em Fechar para voltar.</p>
    </div>,
    document.body
  );
};
